import { render } from "./NotificationsCounterMain.vue?vue&type=template&id=5528bbec&scoped=true&ts=true"
import script from "./NotificationsCounterMain.vue?vue&type=script&lang=ts"
export * from "./NotificationsCounterMain.vue?vue&type=script&lang=ts"

import "./NotificationsCounterMain.vue?vue&type=style&index=0&id=5528bbec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5528bbec"]])

export default __exports__